<template>
  <div>
    <div class="vx-card p-6" style="height: 80vh;">
      <div class="flex flex-wrap mb-12" style="font-size: 40px; justify-content: center;">
        DEMİRBAŞ VE ZİMMET YÖNETİMİ
      </div>

      <form class="vx-row" @submit.prevent="getSearchProduct()">
        <div style="width: 100%;">
          <div class="vx-row ml-0">
            <div class="vx-col md:w-1/6">
              <label class="text-sm mb-1"><b>Personel</b></label>
              <v-select name="stockUserId" v-model="search.chargeUserId" @input="getSearchProduct()" placeholder="Personel" :options="userList" label="userName" class="w-full" :reduce="(row) => row.userId">
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
            </div>

            <div class="vx-col md:w-1/6">
              <label class="text-sm mb-1"><b>Departman</b></label>
              <v-select name="stockUserId" v-model="search.chargeDepartmentId" @input="getSearchProduct()" placeholder="Departman Seçiniz" :options="departmentList" label="departmentName" class="w-full" :reduce="(row) => row.departmentId">
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
            </div>

            <div class="vx-col md:w-1/6">
              <div class="vx-row">
                <div class="vx-col md:w-2/3 w-full">
                  <label class="text-sm"><b>Ürün</b></label>
                  <vs-input type="number" class="w-full" size="large" v-model="search.productId" />
                </div>
                <div class="vx-col mt-5">
                  <feather-icon icon="SearchIcon" class="stoke-current cursor-pointer" @click.stop="productSearchPopupParent = true" />
                  <product-search v-if="productSearchPopupParent" :productSearchPopupProp="productSearchPopupParent" @ProductSearchPopupClosedChildEmit="ProductSearchPopupClosedParent($event)"></product-search>
                </div>
              </div>
            </div>

            <div class="vx-col md:w-1/6">
              <label class="text-sm"><b>Marka</b></label>
              <v-select name="warehouse" placeholder="Seçiniz" v-model="search.brand" :options="productBrandList" :clearable="true" :reduce="(productBrandList) => productBrandList.brandName" label="brandName">
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
            </div>
            <div class="vx-col md:w-1/12 w-full mt-5">
              <b><vs-radio v-model="search.inventoryStockStatus" vs-name="NotAssigned" vs-value="NotAssigned" @input="getSearchProduct()">Bekleyen</vs-radio></b>
            </div>
            <div class="vx-col md:w-1/12 w-full mt-5">
              <b><vs-radio v-model="search.inventoryStockStatus" vs-name="Completed" vs-value="Completed" @input="getSearchProduct()">Tamamlanmış Ürün</vs-radio></b>
            </div>
            <div class="vx-col md:w-1/12 w-full mt-5">
              <b><vs-radio v-model="search.inventoryStockStatus" vs-name="All" vs-value="All" @input="getSearchProduct()">Tümü</vs-radio></b>
            </div>

            <div class="vx-col md:w-1/12">
              <div style="cursor: pointer; width: 165px; color: green; font-weight: bold; font-size: 1.2rem;" class="mt-2 px-4 py-1 flex items-center">
                <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
                <JsonExcel :data="productList" class>Excel</JsonExcel>
              </div>
            </div>
          </div>

          <div class="satis-buton w-full tFlex tFlex_column tFlex_ai-c mt-5">
            <vs-button class="vx-col md:w-1/4 w-full mb-4" style=""> Detaylı Ara</vs-button>
            <p class="text-center md:w-1/4 mb-4"></p>
            <vs-button
              class="vx-col md:w-1/4 w-full mb-4"
              @click="
                () => {
                  productItem = {};
                  chargeProductList = [];
                  productTransactionsPopup = true;
                  addNewCharge = true;
                }
              "
              >Zimmet Ekle</vs-button
            >
          </div>
        </div>
      </form>

      <div>
        <vs-table search noDataText="Ürün bulunamadı" :maxItems="20" :pagination="true" :data="productList">
          <template slot="header"> </template>
          <template slot="thead">
            <vs-th></vs-th>
          </template>
          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :key="i" v-for="(tr, i) in data" class="pt-0 pb-1 md:w-1/4" style="display: inline-block;">
                <vs-td class="pt-0 pb-1 pl-5">
                  <div>
                    <div class="vx-row">
                      <img @click="getProductById(tr)" :src="getThemeIcon('ayarlar.svg')" style="width: 250px; height: 250px; cursor: pointer;" />
                    </div>
                    <div class="vx-row" style="margin: 5px 0px 0px -10px;">
                      <div class="mt-3">
                        <b>Ürün Id:{{ " " + tr.productId }}</b>
                      </div>
                    </div>
                    <div class="vx-row" style="width: 250px;">
                      <div class="mt-3">
                        <b>Ürün:{{ " " + tr.productName }}</b>
                      </div>
                    </div>
                    <div class="vx-row">
                      <div class="mt-3">
                        <b>Fiyat: {{ " " + tr.salePrice }}{{ " " + tr.currencyLogo }}</b>
                      </div>
                    </div>
                    <div class="vx-row" v-if="tr.productType == 'Hardware'">
                      <div class="mt-3" style="">
                        <b>Stok:{{ " " + tr.totalStock }}</b>
                      </div>
                    </div>

                    <div class="vx-row mt-3">
                      <div class="vx-col md:w-1/11" v-if="$store.state.userData.authorizationList.find((f) => f.authorizationId == '16') != null">
                        <feather-icon icon="Edit3Icon" svgClasses="h-6 w-6  hover:text-primary cursor-pointer" title="Ürün Güncelle" @click="getProductById(tr)" />
                      </div>
                    </div>
                  </div>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
      <!--Ürün Bilgileri-->

      <vs-prompt
        :vs-title="addNewCharge == false ? 'Zimmet Bilgisi Güncelle # ' + productItem.productId + ' - ' + productItem.productName : 'Zimmet Ekle'"
        vs-button-cancel="border"
        vs-cancel-text="İptal"
        vs-accept-text="Kaydet"
        @vs-accept="SaveProduct()"
        @vs-close="cancel"
        @vs-cancel="cancel"
        vs-color="warning"
        :vs-active.sync="productTransactionsPopup"
        :vs-buttons-hidden="true"
      >
        <div class="vx-row w-full">
          <div class="vx-col w-full">
            <div class="vx-col">
              <template v-if="productItem.productId">
                <p class="mb-5">
                  <b>{{ "Seçilen Ürün :".padStart(30, "&nbsp;") }}</b> {{ productItem.productId + " - " + productItem.productName + " ( Marka : " + productItem.brand + " )" }}
                </p>
                <p>
                  <b>{{ "Zimmet Kategorisi :".padStart(23, "&nbsp;") }}</b> {{ productItem.inventoryStockTypeName }}
                  <feather-icon
                    icon="TrashIcon"
                    v-if="addNewCharge == true"
                    class="stoke-current text-dark cursor-pointer ml-5"
                    @click.stop="
                      () => {
                        productItem.productId = null;
                      }
                    "
                  />
                </p>
              </template>
              <div v-if="productItem.productId == null" class="vx-row ml-12">
                <p style="margin-top: 5px;">Ürün Seçiniz</p>
                <feather-icon icon="SearchIcon" class="stoke-current cursor-pointer ml-5" @click.stop="productSearchPopupParent = true" />
              </div>
              <product-search v-if="productSearchPopupParent" :productSearchPopupProp="productSearchPopupParent" @ProductSearchPopupClosedChildEmit="ProductSearchPopupClosedParent($event)"></product-search>
            </div>
          </div>
        </div>

        <div class="vx-row w-full">
          <div class="vx-col w-full">
            <vs-table search noDataText="Zimmet Kaydı Bulunamadı" :maxItems="20" :pagination="true" :data="chargeProductList">
              <template slot="header">
                <div class="vx-row w-full">
                  <div class="vx-col w-full" style="text-align: center;">
                    <b style="font-size: 15px; font-weight: 600;"> Zimmetli Kişi veya Zimmetli Departman Bilgileri</b>
                  </div>
                </div>
              </template>
              <template slot="thead">
                <vs-th width="175px">Seri Kodu</vs-th>
                <vs-th width="175px">Atayan / Atayacak</vs-th>
                <vs-th width="250px">Sorumlu Kişi</vs-th>
                <vs-th width="250px">Departman</vs-th>
                <vs-th width="150px">Zimmet Tarihi</vs-th>
                <vs-th width="10">Durum</vs-th>
                <vs-th width="150px">Atama / Çıkarma</vs-th>
              </template>
              <template slot-scope="{ data }">
                <tbody :key="tr.hrShiftId" v-for="(tr, i) in data">
                  <vs-tr :state="tr.userId > 0 ? 'warning' : null">
                    <template>
                      <vs-td class="pt-3 pb-3" style="white-space: nowrap;">
                        <a target="_blank" :href="'/ProductBySerialCode/' + tr.serialCode" style="color: green; font-weight: bold;">{{ tr.serialCode }}</a>
                      </vs-td>

                      <vs-td class="pt-0 pb-1">
                        <template v-if="tr.userId > 0">
                          <b> {{ tr.userName }}</b>
                        </template>
                        <template v-else>
                          <b> {{ $store.state.userData.userName }}</b>
                        </template>
                      </vs-td>

                      <vs-td class="pt-0 pb-1">
                        <template v-if="tr.userId > 0">
                          <b> {{ tr.chargeUserName }}</b>
                        </template>
                        <template v-else>
                          <v-select name="userId" v-model="tr.chargeUserId" placeholder="Zimmetli Kişi" :options="userList" label="userName" class="w-full" :reduce="(row) => row.userId">
                            <span slot="no-options">Eşleşen Veri Yok</span>
                          </v-select>
                        </template>
                      </vs-td>
                      <vs-td class="pt-0 pb-1">
                        <template v-if="tr.userId > 0">
                          <b> {{ tr.chargeDepartmentName }}</b>
                        </template>
                        <template v-else>
                          <v-select name="stockUserId" v-model="tr.chargeDepartmentId" placeholder="Departman Seçiniz" :options="departmentList" label="departmentName" class="w-full" :reduce="(row) => row.departmentId">
                            <span slot="no-options">Eşleşen Veri Yok</span>
                          </v-select>
                        </template>
                      </vs-td>
                      <vs-td class="pt-0 pb-1">
                        <b> {{ tr.chargeDate }}</b>
                      </vs-td>
                      <vs-td class="pt-0 pb-1">
                        <b> {{ tr.status }}</b>
                      </vs-td>
                      <vs-td class="pt-0 pb-1">
                        <div v-if="$store.state.userData.authorizationList.find((f) => f.authorizationId == '22') != null" style="flex-flow: nowrap; width: max-content;">
                          <feather-icon
                            v-if="tr.userId == null"
                            icon="UserPlusIcon"
                            title="Kaydet"
                            svgClasses="h-5 mr-5 hover:text-danger cursor-pointer"
                            @click="
                              () => {
                                tr.operation = 'T';
                                SaveCharge(tr, 'Zimmet ataması yapılacaktır.');
                              }
                            "
                          />
                          <feather-icon
                            v-if="tr.userId > 0 && tr.status == 'O'"
                            icon="UserXIcon"
                            title="Sil"
                            svgClasses="h-5 mr-5 hover:text-danger cursor-pointer"
                            @click="
                              () => {
                                tr.operation = 'D';
                                SaveCharge(tr, 'Zimmet kaldırılacaktır.');
                              }
                            "
                          />
                        </div>
                      </vs-td>
                    </template>
                  </vs-tr>
                </tbody>
              </template>
            </vs-table>
          </div>
        </div>
      </vs-prompt>

      <!--Stok Bilgileri-->

      <vs-prompt :vs-title="'Stok Bilgileri # ' + this.warehouseStock.productId + '-' + this.warehouseStock.productName" vs-button-cancel="border" :vs-buttons-hidden="true" @vs-cancel="cancel" :vs-active.sync="stockTransactionsPopup">
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-table search noDataText="Ürün Bulunamadı!" :data="stockList.warehouseStock">
              <template slot="header"> </template>

              <template slot="thead">
                <vs-th>Ürün Id</vs-th>
                <vs-th>Ürün Adı</vs-th>
                <vs-th>Stok</vs-th>
                <vs-th>Depo</vs-th>
                <vs-th v-if="stockList && stockList[0] && stockList[0].forceBarcode">Seri No</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr v-for="(tr, i) in data" :key="i">
                  <vs-td>{{ tr.productId }}</vs-td>
                  <vs-td>{{ tr.productName }}</vs-td>
                  <vs-td>{{ tr.amount }}</vs-td>
                  <vs-td>{{ tr.warehouseName }}</vs-td>
                  <vs-td v-if="stockList && stockList[0] && stockList[0].forceBarcode">
                    <a href="#" @click="openSerialNoPopup(tr)">Seri Numaraları Göster</a>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </vs-prompt>
      <vs-popup id="popupDisplay" :title="'Seri No # ' + this.warehouseStock.productId + '-' + this.warehouseStock.productName" :active.sync="popup.show">
        <div v-for="(tr, index) in popup.serialCodeList" :key="index" class="pt-0 pb-1 md:w-1/3" style="display: inline-block;">
          <a target="_blank" :href="'/ProductBySerialCode/' + tr.SerialCode" style="color: green; font-weight: bold;">{{ tr.SerialCode }}</a>
          <br />
          <br />
        </div>
      </vs-popup>

      <!--SmartStore Bilgileri-->
      <vs-prompt vs-title="SmartStore  Bilgileri" vs-button-cancel="border" :vs-buttons-hidden="true" @vs-cancel="cancel" :vs-active.sync="smartStorePopup">
        <vs-tabs>
          <vs-tab label="Ürün Bilgileri" icon-pack="feather" icon="icon-user">
            <div v-if="smartStoreInfo[0]" class="vx-row mt-10">
              <div class="vx-col w-full" style="text-align: -webkit-center;">
                <b>SMARTSTORE Ürün Bilgileri</b>
              </div>
              <div class="vx-row mt-10" style="margin-left: 15px;">
                <div class="vx-col">
                  <label>Ürün Link</label>
                </div>
                <div class="vx-col">
                  <a :href="smartStoreInfo[0].productLink">{{ productList && productList[0] && productList[0].productName }}</a>
                </div>
              </div>

              <div class="vx-row mt-10" style="margin-left: 15px;">
                <div class="vx-col">
                  <label>Ürün Fiyat (KDV Hariç)</label>
                </div>
                <div class="vx-col">
                  <b>{{ smartStoreInfo[0].currentPrice }} $ </b>
                </div>
              </div>

              <div class="vx-row mt-10" style="margin-left: 15px;">
                <div class="vx-col">
                  <label>Ürün Ağırlık</label>
                </div>
                <div class="vx-col">
                  <b>{{ smartStoreInfo[0].weight }} kg </b>
                </div>
              </div>
              <div class="vx-row mt-10" style="margin-left: 15px;">
                <div class="vx-col">
                  <label>Ürün Ölçüleri(Yükseklik X Genişlik X Derinlik)</label>
                </div>
                <div class="vx-col">
                  <b>{{ smartStoreInfo[0].height + " x " + smartStoreInfo[0].width + " X " + smartStoreInfo[0].length }}</b>
                </div>
              </div>
              <div class="vx-row mt-10" style="margin-left: 15px;">
                <div class="vx-col">
                  <label>Güncelleme Süresi</label>
                </div>
                <div class="vx-col">
                  <b>{{ smartStoreInfo[0].updateDuration }}</b>
                </div>
              </div>

              <div class="vx-row mt-10" style="margin-left: 15px;">
                <div class="vx-col">
                  <label>Güncelleme Bedeli</label>
                </div>
                <div class="vx-col">
                  <b>{{ smartStoreInfo[0].updateCost }} </b>
                </div>
              </div>

              <div class="vx-row mt-10" style="margin-left: 15px;">
                <div class="vx-col">
                  <label>Ürün Açıklaması</label>
                </div>
                <div class="vx-col vx-card mt-2" v-html="smartStoreInfo[0].fullDescription" style="overflow-y: scroll; height: 500px;"></div>
              </div>
            </div>
            <div v-else class="vx-row mt-10">
              <div class="vx-col w-full" style="text-align: -webkit-center;">
                <b>SMARTSTORE VERİSİ MEVCUT DEĞİL</b>
              </div>
            </div>
          </vs-tab>
          <vs-tab label="Teknik Bilgiler" icon-pack="feather" icon="icon-info">
            <div v-if="smartStoreInfo[0]" class="vx-row mt-10">
              <div class="vx-col w-full" style="text-align: -webkit-center;">
                <b>SMARTSTORE Teknik Servis Bilgileri</b>
              </div>
              <div class="vx-row mt-10" style="margin-left: 15px;">
                <div class="vx-col">
                  <label>Teknik Servis Bilgileri</label>
                </div>
                <div class="vx-col vx-card mt-2" v-html="smartStoreInfo[0].technicalServiceInformation" style="overflow-y: scroll; height: 500px;"></div>
              </div>
            </div>
          </vs-tab>
        </vs-tabs>
      </vs-prompt>
      <!--Sepete Ürün Ekle-->
      <vs-prompt vs-title="Sepete Ürün Ekle" vs-button-cancel="border" vs-accept-text="Ekle" vs-cancel-text="Vazgeç" @vs-accept="saveSaleOrderBasket()" @vs-close="cancel" @vs-cancel="cancel" vs-color="warning" :vs-active.sync="saveBasketPopup">
        <div>
          <ag-grid-vue
            style="height: 50vh;"
            ref="agGridTable"
            :gridOptions="gridOptions"
            class="ag-theme-material w-100 my-4 ag-grid-table"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :rowData="saleProductList"
            rowSelection="multiple"
            colResizeDefault="shift"
            :animateRows="true"
            :floatingFilter="true"
            :pagination="true"
            :paginationPageSize="paginationPageSize"
            :suppressPaginationPanel="true"
            :rowClassRules="rowClassRules"
          ></ag-grid-vue>
        </div>

        <vs-pagination :total="totalPages" :max="5" v-model="currentPage" />
      </vs-prompt>
      <!--------------Müşteri Aksiyonları--------------------->
      <vs-prompt vs-title="Müşteri Aksiyonları" vs-button-cancel="border" :vs-buttons-hidden="true" @vs-cancel="cancel" :vs-active.sync="customerActionsPopup">
        <div>
          <vs-table search noDataText="Hiç Mesaj Yok" :data="customers" pagination :max-items="10">
            <template slot="header">
              <div class="flex items-end items-center px-3">
                <feather-icon svgClasses="w-6 h-6" icon="VoicemailIcon" class="mr-2" />
                <span class="font-medium text-lg leading-none mr-10">Müşteri Aksiyonları</span>
                <div style="cursor: pointer; width: 100px;" class="px-4 py-1 flex items-center">
                  <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
                  <JsonExcel :data="customers">İndir</JsonExcel>
                </div>
              </div>
            </template>
            <template slot="thead">
              <vs-th style="width: 50%;">Müşteri</vs-th>
              <vs-th>Şehir</vs-th>
              <vs-th>Telefon</vs-th>
              <vs-th>Satış Id</vs-th>
              <vs-th v-if="customers && customers[0] && customers[0].forceBarcode">Seri No</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :stripe="true" v-for="(tr, i) in data" :key="i">
                <vs-td>{{ tr.customer }}</vs-td>
                <vs-td>{{ tr.city }}</vs-td>
                <vs-td>{{ tr.phone }}</vs-td>
                <vs-td>
                  <a :href="'/SaleByOrderId/' + tr.saleOrderId" target="_blank" style="color: #00acc1;"
                    ><b>{{ tr.saleOrderId }}</b></a
                  >
                </vs-td>
                <vs-td v-if="customers && customers[0] && customers[0].forceBarcode">
                  <a :href="'/ProductBySerialCode/' + tr.serialCode" target="_blank" style="color: #00897b;"
                    ><b>{{ tr.serialCode }}</b></a
                  >
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-prompt>
    </div>
  </div>
</template>
<script>
import { repository } from "@/_services/repository.js";
import JsonExcel from "vue-json-excel";
import vSelect from "vue-select";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import ProductSearch from "../Search/ProductSearch.vue";
export default {
  components: {
    vSelect,
    JsonExcel,
    AgGridVue,
    ProductSearch,
  },

  data() {
    return {
      departmentList: [],
      addNewCharge: false,
      chargeProductList: [],
      productSearchPopupParent: false,
      stockInventoryTypeList: [],
      userList: [],
      productList: [],
      product: [],
      searchProductList: [],
      stockList: [],
      saleProductList: [],
      currencyList: [],
      selectedRow: [],
      basketList: [],
      warehouseList: [],
      produceTypeList: ["Purchase", "Produce", "Raw Material"],
      smartStoreInfo: [{ productLink: null, fullDescription: null, length: null, height: null, width: null, weight: null, currentPrice: null, updateDuration: null, updateCost: null, technicalServiceInformation: null }],
      supplierList: [],
      customers: [],
      serialCode: [],
      productBrandList: [],
      brandSearch: { brandName: null },
      searchName: undefined,
      productTransactionsPopup: false,
      stockTransactionsPopup: false,
      smartStorePopup: false,
      saveBasketPopup: false,
      showBasketPopup: false,
      customerActionsPopup: false,
      popup: { show: false, serialCodeList: [] },
      productItem: {
        productId: null,
        productName: null,
        productDescription: null,
        invoiceName: null,
        brand: null,
        forceBarcode: 1,
        requiresSubscription: null,
        onlineDelivery: null,
        productWeight: null,
        productLink: null,
        minPrice: null,
        minPriceCurrencyId: null,
        owningCost: null,
        owningCostCurrencyId: null,
        salePrice: null,
        salePriceCurrencyId: null,
        productType: null,
        productCategoryId: null,
        updatePeriod: null,
        relatedActivationProductId: null,
        produceId: null,
        produceAmount: null,
        produceType: null,
        supplierId: null,
        supplierName: null,
      },
      warehouseStock: {
        productId: null,
        productName: null,
        amount: null,
        warehouseId: null,
        warehouseName: null,
      },
      saleOrderId: this.$route.params.saleOrderId,
      search: { productId: null, brand: null, productType: null, warehouseId: null, warehouseName: null, totalStock: null, showInStock: 1, inventoryStockStatus: "NotAssigned" },
      v1Search: { productId: null, productName: null, stock: null, wareHouseId: null, wareHouse: null, forceBarcode: null, salePrice: null, salePriceCurrencyId: null },
      saleOrderBasket: { id: null, date: null, userId: null, userName: null, productId: null, productName: null, amount: null, salePrice: null, salePriceCurrencyId: null, logo: null, warehouseId: null },
      delayedSearchTimer: "",
      gridApi: null,
      rowClassRules: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          checkboxSelection: true,
          headerName: "Ürün Id",
          field: "productId",
          editable: false,
          width: 200,
        },
        {
          headerName: "Ürün",
          field: "productName",
          editable: false,
          width: 300,
        },
        {
          headerName: "Stok",
          field: "stock",
          editable: false,
          width: 100,
        },
        {
          headerName: "Depo",
          field: "wareHouse",
          filter: true,
          editable: false,
          width: 200,
        },
        {
          headerName: "Birim Fiyatı",
          field: "salePriceStr",
          editable: false,
          width: 100,
        },
        {
          headerName: "Satış Fiyatı",
          field: "sellPrice",
          editable: true,
          width: 150,
        },
        {
          headerName: "Adet",
          field: "amount",
          editable: true,
          width: 100,
        },
      ],
    };
  },

  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 12;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },

  methods: {
    ProductSearchPopupClosedParent: async function (v) {
      this.productSearchPopupParent = false;
      if (v) {
        this.search.productId = v.productId;
        this.productItem.productId = v.productId;
        this.productItem.productName = v.productName;
        this.productItem.brand = v.brand;
        this.getchargeProductList();
      } else {
        this.search.productId = null;
        this.productItem.productId = null;
        this.productItem.productName = null;
      }
      console.log("product child is closed", v);
    },
    cancel() {
      this.productItem = {
        productId: null,
        productName: null,
        productDescription: null,
        invoiceName: null,
        brand: null,
        forceBarcode: null,
        requiresSubscription: null,
        onlineDelivery: null,
        productWeight: null,
        productLink: null,
        minPrice: null,
        minPriceCurrencyId: null,
        owningCost: null,
        owningCostCurrencyId: null,
        salePrice: null,
        salePriceCurrencyId: null,
        productType: null,
        productCategoryId: null,
        updatePeriod: null,
        relatedActivationProductId: null,
        produceId: null,
        produceAmount: null,
        produceType: null,
      };
    },
    openSerialNoPopup(tr) {
      this.popup.show = true;
      this.popup.serialCodeList = tr.serialCodeList;
    },

    getProductById: async function (tr) {
      this.addNewCharge = false;
      this.productTransactionsPopup = true;
      this.productItem = {};
      this.productItem = tr;
      this.$vs.loading();
      let list = await repository.postEntity("Product/GetProductDetail", { ProductId: this.productItem.productId }).then((r) => r.list);
      this.productItem = list[0];

      await this.getchargeProductList();

      this.$vs.loading.close();
    },
    getWarehouseStockById: async function (tr) {
      this.stockTransactionsPopup = true;
      this.warehouseStock = tr;
      this.$vs.loading();
      let list = await repository.postEntity("Stock/getWarehouseStock", { ProductId: this.warehouseStock.productId, warehouseId: 37 }).then((r) => r.list);
      this.stockList = list;
      let temp = [];

      for (let a = 0; a < this.stockList.length; a++) {
        temp.push({
          productId: this.stockList[a].productId,
          productName: this.stockList[a].productName,
          amount: this.stockList[a].amount,
          warehouseName: this.stockList[a].warehouseName,
          serialCodeList: JSON.parse(this.stockList[a].serialCodeJson),
        });
      }
      this.stockList.warehouseStock = temp;
      this.$vs.loading.close();
    },
    getProductSmartStoreInfoById: async function (tr) {
      this.smartStorePopup = true;
      this.productItem = tr;
      this.$vs.loading();
      this.smartStoreInfo = await repository.getAll("Product/getProductSmartStoreInfo/" + this.productItem.productId).then((row) => row.list);
      this.$vs.loading.close();
    },
    getCustomerActions: async function (tr) {
      this.customerActionsPopup = true;
      this.productItem = tr;
      this.$vs.loading();
      this.product = await repository.getAll("Product/" + this.productItem.productId).then((r) => r.list);
      this.customers = JSON.parse(this.product[0].customers);
      console.log("test", this.customers);
      this.$vs.loading.close();
    },
    addToBasket: async function (tr) {
      this.saveBasketPopup = true;
      this.v1Search = tr;
      this.$vs.loading();
      let list = await repository.postEntity("Product/getProductsV1Search", { ProductId: this.v1Search.productId }).then((row) => row.list);
      this.saleProductList = list;
      this.$vs.loading.close();

      this.rowClassRules = {};
      this.gridApi = this.gridOptions.api;
      this.gridApi.sizeColumnsToFit();
    },

    SaveCharge: async function (item, messageText) {
      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        text: messageText,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();
      await repository.postEntity("Stock/SaveCharge", item);

      this.$vs.loading.close();

      await this.$swal.fire({
        icon: "success",
        title: "İşlem Başarılı",
        //text: "",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tamam",
        cancelButtonText: "Hayır",
      });

      this.getProductById(item);
    },

    SaveProduct: async function () {
      this.productTransactionsPopup = true;
      if (this.productItem.productId > 0) {
        let resultConfirm = await this.$swal.fire({
          icon: "warning",
          text: `${this.productItem.productId} Id'li Ürünü güncellemek istediğinize emin misiniz?`,
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Evet",
          cancelButtonText: "Hayır",
        });
        if (resultConfirm.isConfirmed) {
          this.$vs.loading();
          await repository.postEntity("Product/editProduct", this.productItem);
          this.$vs.loading.close();
          await this.$swal.fire({ icon: "success", title: "Güncelleme başarılı." });
          this.productTransactionsPopup = false;
          location.reload();
        } else {
          return;
        }
      } else {
        let result = await this.$swal.fire({
          icon: "warning",
          text: `Ürün eklemek istediğinize emin misiniz?`,
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Evet",
          cancelButtonText: "Hayır",
        });
        if (result.isConfirmed) {
          this.$vs.loading();
          await repository.postEntity("Product/createProduct", this.productItem);
          this.$vs.loading.close();
          await this.$swal.fire({ icon: "success", title: "Ürün eklendi." });
          this.productTransactionsPopup = false;
          this.productItem = {
            productId: null,
            productName: null,
            productDescription: null,
            invoiceName: null,
            brand: null,
            forceBarcode: null,
            requiresSubscription: null,
            onlineDelivery: null,
            productWeight: null,
            productLink: null,
            minPrice: null,
            minPriceCurrencyId: null,
            owningCost: null,
            owningCostCurrencyId: null,
            salePrice: null,
            salePriceCurrencyId: null,
            productType: null,
            productCategoryId: null,
          };
        } else {
          return;
        }
      }
    },
    deleteProduct: async function (tr) {
      this.productItem = tr;
      let productId = parseInt(this.productItem.productId);
      let result = await this.$swal.fire({
        icon: "warning",
        text: `${productId} Id'li ürünü silmek istediğinize emin misiniz?`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });
      if (result.isConfirmed) {
        this.$vs.loading();
        await repository.deleteWithParam("Product/productDelete?productId", productId);
        this.$vs.loading.close();
        await this.$swal.fire({ icon: "success", title: "Ürün silinmiştir." });
        location.reload();
      }
    },
    saveSaleOrderBasket: async function () {
      this.selectedRow = this.gridOptions.api.getSelectedRows()[0];

      this.saleOrderBasket = {
        productId: this.selectedRow.productId,
        salePrice: this.selectedRow.sellPrice,
        salePriceCurrencyId: this.v1Search.salePriceCurrencyId,
        amount: this.selectedRow.amount,
        warehouseId: this.selectedRow.wareHouseId,
      };
      let resultConfirm = await this.$swal.fire({
        icon: "warning",
        text: `${this.saleOrderBasket.productId} Id'li Ürünü sepete eklemek istediğinize emin misiniz?`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });
      if (resultConfirm.isConfirmed) {
        this.$vs.loading();
        let saveBasket = await repository.postEntity("Product/saveSaleOrderBasket", this.saleOrderBasket).then((r) => r.list);
        this.$vs.loading.close();
        await this.$swal.fire({ icon: "success", title: "Ürün sepete eklenmiştir." });
      } else {
        return;
      }
    },
    getProductsV1: async function () {
      this.$vs.loading();
      this.productList = await repository.getAll("Product/getProductsV1").then((r) => r.list);
      this.$vs.loading.close();
    },

    GetStockInventoryType: async function () {
      this.stockInventoryTypeList = await repository.postEntity("Stock/GetInventoryStockType", {}).then((r) => r.list);
    },

    getCurrencies: async function () {
      this.currencyList = await repository.getAll("Accounting/getCurrencies").then((r) => r.list);
    },
    getProductSmartStoreInfo: async function () {
      this.smartStoreInfo = await repository.getAll("Product/getProductSmartStoreInfo/" + this.productItem.productId).then((row) => row.list);
    },
    getSearchProduct: async function () {
      this.$vs.loading();
      this.productList = await repository.postEntity("Stock/getProductSearchForInventoryStock", this.search).then((r) => r.list);
      this.$vs.loading.close();
    },

    getSupplier: async function () {
      let searchModel = {
        searchName: this.searchName,
        supplierPageNumber: this.supplierPageNumber,
      };

      let list = await repository.postEntity("Purchase/getSupplier", searchModel).then((r) => r.list);

      if (list) this.supplierList = list;
    },

    getUsers: async function () {
      this.userList = await repository.postEntity("HumanResource/getUser", { status: 1 }).then((r) => r.list);
    },

    getchargeProductList: async function () {
      this.chargeProductList = await repository.postEntity("Stock/getchargeProductList", { productId: this.productItem.productId, chargeDepartmentId: this.productItem.chargeDepartmentId }).then((r) => r.list);
    },

    getDepartment: async function () {
      this.departmentList = await repository.getAll("HumanResource/getDepartment").then((r) => r.list);
    },
    getProductBrand: async function () {
      this.productBrandList = await repository.postEntity("Product/GetProductBrand", this.brandSearch).then((r) => r.list);
    },
  },
  created: async function () {
    if (this.$route.params != null && this.$route.name == "InventoryStockByProductId" && this.$route.params.productId > 0) {
      this.search.productId = this.$route.params.productId;
    }

    await Promise.all([this.GetStockInventoryType(), this.getCurrencies(), this.getSupplier(), this.getUsers(), this.getSearchProduct(), this.getDepartment(), this.getProductBrand()]);
  },

  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        if (this.customerActionsPopup == true) this.customerActionsPopup = false;
        if (this.saveBasketPopup == true) this.saveBasketPopup = false;
        if (this.smartStorePopup == true) this.smartStorePopup = false;
        if (this.stockTransactionsPopup == true) this.stockTransactionsPopup = false;
        if (this.productTransactionsPopup == true) this.productTransactionsPopup = false;
      }
    });
  },
};
</script>
